import {lazy} from 'react'

export const VoyageStadiumLazy = lazy(() => import('@containers/voyageStadium/VoyageStadium'))
